import { render, staticRenderFns } from "./ProgramInfoForm.vue?vue&type=template&id=93309a06&scoped=true"
import script from "./ProgramInfoForm.vue?vue&type=script&lang=js"
export * from "./ProgramInfoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93309a06",
  null
  
)

export default component.exports